export default __webpack_public_path__ + "static/media/3c.1f4d51ab.png";